import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useState } from "react";
import BadgeIcon from "../../../../components/Vectors/BadgeIcon";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../store/store"; // Adjust the path based on your project structure
import { IMaskInput } from "react-imask";
import { Address } from "../../../../@types/subscriptionInfo";
import { add } from "../../../../store/addressSlice";
import SubscriptionService from "../../../../services/SubscriptionService";
import { addSubscriptionInfo } from "../../../../store/associateSlice";
import AddressService from "../../../../services/AdressService";

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const TextMaskCustom = React.forwardRef<HTMLElement, CustomProps>(
  function TextMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="00000-000"
        definitions={{
          "#": /[1-9]/,
        }}
        inputRef={ref as any}
        onAccept={(value: any) =>
          onChange({ target: { name: props.name, value } })
        }
        overwrite
      />
    );
  }
);

interface ZipCodeInfoProps {
  handleNextStep(step: string): void;
  close(): void;
}

const ZipCodeInfo: React.FC<ZipCodeInfoProps> = ({ handleNextStep, close }) => {
  interface ZipCodeInfoAttributes {
    zipCode: string;
  }

  const dispatch = useDispatch();

  const user = useSelector((state: RootState) => state.profileSlice.profile?.person);

  const [values, setValues] = useState<ZipCodeInfoAttributes>({
    zipCode: "",
  });

  const [loading, setLoading] = useState<boolean>(false);

  const [address, setAddress] = useState<Address | null>(null);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  useEffect(() => {
    const findAddress = async () => {
      const zipCode = values.zipCode.replace(/\D/g, "");
      const isFieldFilled = zipCode.length === 8;
      if (isFieldFilled) {
        setLoading(true);
        const address: Address = await AddressService.find(zipCode);
        setLoading(false);
        if (address) {
          setAddress(address);
          dispatch(add(address));
          const subscriptionInfo = await SubscriptionService.getInfos();
          dispatch(addSubscriptionInfo(subscriptionInfo));
        }
        return;
      }
    };
    findAddress();
  }, [values, dispatch]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          margin: 2,
        }}
      >
        <IconButton>
          <CloseIcon onClick={close} />
        </IconButton>
      </Box>

      <Box
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        paddingY={3}
        paddingX={6}
        gap={1}
      >
        <BadgeIcon />
        <Typography fontWeight="600" fontSize="20px" color={"black"}>
          Olá {user?.name}! Complete seus dados.
        </Typography>

        <Typography
          fontWeight="400"
          fontSize="14px"
          color={"#8087A6"}
          align="center"
        >
          Para antecipar os seus recebíveis é necessário completarmos seu
          cadastro.
        </Typography>
      </Box>
      <Box paddingX={3} display={"flex"} width={"180px"}>
        <TextField
          label="CEP"
          variant="standard"
          value={values.zipCode}
          onChange={handleChange}
          name="zipCode"
          id="formatted-text-mask-input"
          InputProps={{
            inputComponent: TextMaskCustom as any,
            endAdornment: (
              <Box sx={{ width: "20px" }}>
                {loading && <CircularProgress size="1rem" />}
              </Box>
            ),
          }}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          margin: 2,
        }}
      >
        <Button
          onClick={() => {
            handleNextStep("businessAddress");
          }}
          variant="contained"
          sx={{ marginLeft: 1 }}
          disabled={!address}
        >
          Próximo
        </Button>
      </Box>
    </>
  );
};

export default ZipCodeInfo;
